import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionItems } from 'src/app/models/actionItems';
import { AddActionItemComponent } from '../assessment-ft/action-items/add-action-item/add-action-item.component';

@Component({
  selector: 'app-goals',
  templateUrl: './goals.component.html',
  styleUrls: ['./goals.component.scss']
})
export class GoalsComponent implements AfterViewInit {

  @ViewChild(AddActionItemComponent) child;

  constructor(
    private router: Router
  ) { }

  goalList: ActionItems [];

  ngAfterViewInit() {
    this.goalList = this.child.goalList;
  }

  removeGoal(index:number) {
    if(index > -1) {
      this.goalList.splice(index,1);
    }
  }
}
